/**
 * This fixes a Glider bug where if the last visible slide is partially visible, Glider does not add "visible" class
 * like it does to other visible slides. This fixes it by adding the "visible" class if needed.
 * @param {*} gliderInstance The Glider instance
 * @returns void
 */
function initGliderSlideVisibleFix (gliderInstance) {

	if (!gliderInstance || !gliderInstance.ele) {

		return;

	}

	const {
		ele, itemWidth, opt, slides
	} = gliderInstance;
	const { slidesToShow } = opt;
	const totalSlides = slides.length;

	if (totalSlides === 1 || slidesToShow === 1 || totalSlides < slidesToShow) {

		return;

	}

	const addVisibleClassIfPartiallyVisible = (slideEl) => {

		if (slideEl) {

			if (!slideEl.classList.contains('visible')) {

				const lastVisibleSlideRect = slideEl.getBoundingClientRect();
				const gliderContainerRect = ele.getBoundingClientRect();
				const cutoffPixels = lastVisibleSlideRect.right - gliderContainerRect.right;
				const offset = 1; // Visible pixel allowed to be treated as still hidden

				// Is the slide partially cut off?
				if (cutoffPixels > 0 && cutoffPixels < itemWidth - offset) {

					slideEl.classList.add('visible');

				}

			}

		}

	};

	// We could have used 'glider-animated' event but it is buggy in Safari where the event is triggered too early
	// while the sliding animation seems to be still ongoing causing Glider to set the wrong current slide.
	const observer = new MutationObserver((mutations) => {

		Array.from(mutations).some((mutation) => {

			const { target } = mutation;

			// Locate the center slide and use it as reference to the last slide
			if (target.matches('.glider-slide.center')) {

				const centerSlideIndex = Number(target.dataset.gslide);
				const slideCount = Math.floor(slidesToShow / 2);
				const lastSlideIndex = centerSlideIndex + slideCount - 1;
				const slidesToCheck = 3; // Check more than 1 slide for more coverage

				[ ...Array(slidesToCheck) ].forEach((_, i) => {

					const lastVisibleSlide = slides[lastSlideIndex + i];
					addVisibleClassIfPartiallyVisible(lastVisibleSlide);

				});
				return true;

			}
			return false;

		});

	});

	observer.observe(ele, {
		subtree: true,
		attributes: true,
		attributeFilter: [ 'class' ]
	});

	ele.addEventListener('glider-destroy', () => {

		observer.disconnect();

	});

}

export default initGliderSlideVisibleFix;
